

(function pageDirectiveDefinition() {

    function createPageFactory(layoutName) {
        return ['config', '$compile',
            function pageDirectiveFactory(config, $compile) {

                return {
                    templateUrl: function(element, attrs) {
                        return config.resourceUrl('/components/ui/design/layout/' + layoutName + '.html');
                    },
                    transclude: true,
                    restrict: 'E',
                    scope: false,
                    priority: 80,   // no puede ser mas alto porque sino no se interpola
                    terminal: true,
                    controller: [
                        '$scope', '$element', '$attrs',
                        function pageController($scope, $element, $attrs) {

                            var that = this;

                            that.titleContainerClass = ['row'];

                            $attrs.$observe('heading', function(value) {
                                that.title = value;
                            });

                            $attrs.$observe('description', function(value) {
                                that.description = value;
                            });

                            $attrs.$observe('titleCondition', function(value) {
                                that.titleCondition = value;
                            });

                            $attrs.$observe('titleContainerClass', function (value) {
                                if (value) {
                                    that.titleContainerClass = $scope.$eval(value);
                                } else {
                                    that.titleContainerClass = ['row'];
                                }
                            });
                        }
                    ],
                    compile: function pageController($scope, $element, $attrs, ctrl, $transcludeFn) {

                        // Muevo las directivas de page al container (por ej show-loading).
                        var elem = $element.$$element;

                        var container = elem.children(':first-child');
                        var attributes = [];

                        angular.forEach(elem[0].attributes, function (attr) {
                            attributes.push({ name: attr.name, value: attr.value });
                        });

                        angular.forEach(attributes, function (attribute) {
                            if (attribute.name !== 'heading' && attribute.name.charAt(0) !== '$') {
                                if (attribute.name === 'class') {
                                    container.addClass(attribute.value);
                                } else {
                                    container.attr(attribute.name, attribute.value);
                                }
                                elem.removeAttr(attribute.name);
                            }
                        });

                        return {
                            post: function pageController($scope, $element, $attrs, ctrl, $transcludeFn) {
                                
                                $transcludeFn($scope, function(clone) {
                                    $element.find('.page-content').empty().append(clone);
                                });

                            }
                        }
                    },
                    controllerAs: 'page'
                };

            }
        ];
    }

    angular.module('ui.Layout')
           .directive('page', createPageFactory('page'))
           .directive('pageFluid', createPageFactory('page-fluid'))
           .directive('pageFluidSm', createPageFactory('page-fluid-sm'))
           .directive('pageFull', createPageFactory('page-fluid-full'))

})();